import { colors, InputText, Select } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const FormBodyWrapperStyled = styled.div`
  width: 100%;
  padding: 0 3.2rem 6rem;
  box-sizing: border-box;
`;

export const FirstRowStyled = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  padding-bottom: 4rem;
  border-bottom: 1px solid ${colors.neutral[300]};
`;

export const SelectStyled = styled(Select)`
  flex-grow: 0;
`;

export const InputTextStyled = styled(InputText)`
  flex-grow: 0;
`;

export const SectionHeadingStyled = styled.h3`
  font-size: 1.8rem;
  line-height: 2.4rem;
  letter-spacing: 0.02rem;
  color: ${colors.neutral[900]};
  font-weight: 700;
  text-align: center;
  padding-top: 2.6rem;
  padding-bottom: 1rem;
  margin: 0;
`;

export const SectionCaptionStyled = styled.p`
  margin: 0;
  color: ${colors.neutral[700]};
  text-align: center;
  font-size: 1.6rem;
  line-height: 2.4rem;
  letter-spacing: 0.02rem;
  padding-bottom: 2.6rem;
`;
